import {
  updateLocationAlert,
  calculateShearWaveSpeed,
  calculateThickness,
  calculateStudyProgress,
  setAcquiring,
  setFocusElement,
  setMainViewSection,
  setAverageThickness,
  setAverageShearWaveSpeed,
  selectLocation,
} from ".";

import { csiTypes } from "../constants/constants";

export const SET_SAMPLE_DATA_AVAILABLE = "SET_SAMPLE_DATA_AVAILABLE";
export function setSampleDataAvailable(id, status) {
  return {
    type: SET_SAMPLE_DATA_AVAILABLE,
    id: id,
    status: status,
  };
}

export const SET_SAMPLE_DATA_SAVED = "SET_SAMPLE_DATA_SAVED";
export function setSampleDataSaved(id, status) {
  return {
    type: SET_SAMPLE_DATA_SAVED,
    id: id,
    status: status,
  };
}

export const SET_SAMPLES_DONE_FLAG = "SET_SAMPLES_DONE_FLAG";
export function setSamplesDoneFlag(status) {
  return {
    type: SET_SAMPLES_DONE_FLAG,
    status: status,
  };
}

export const SET_SAMPLES_SAVED_FLAG = "SET_SAMPLES_SAVED_FLAG";
export function setSamplesSavedFlag(status) {
  return {
    type: SET_SAMPLES_SAVED_FLAG,
    status: status,
  };
}

export const REMOVE_ACQ_SAMPLE = "REMOVE_ACQ_SAMPLE";
export function removeAcqSampleById(
  samples,
  acqType,
  allIds,
  idByType,
  locationId,
  locationSamples
) {
  return {
    type: REMOVE_ACQ_SAMPLE,
    samples: samples,
    acqType: acqType,
    allIds: allIds,
    idByType: idByType,
    locationId: locationId,
    locationSamples: locationSamples,
  };
}

export const REMOVE_ERRORED_SAMPLE = "REMOVE_ERRORED_SAMPLE";
export function removeErroredSample(
  samples,
  acqType,
  allIds,
  idByType,
  locationId,
  locationSamples,
  allAcqTypes
) {
  return {
    type: REMOVE_ERRORED_SAMPLE,
    samples: samples,
    acqType: acqType,
    allIds: allIds,
    idByType: idByType,
    locationId: locationId,
    locationSamples: locationSamples,
    allAcqTypes: allAcqTypes,
  };
}

export const TOGGLE_BMODE_SET_TO_AUTO_DETECTED_THICKNESS =
  "TOGGLE_BMODE_SET_TO_AUTO_DETECTED_THICKNESS";
export function toggleBmodeSetToAutoDetectedThickness(id) {
  return {
    type: TOGGLE_BMODE_SET_TO_AUTO_DETECTED_THICKNESS,
    id,
  };
}

export const SET_SAMPLE_PROCESSING = "SET_SAMPLE_PROCESSING";
export function setSampleProcessing(id, status) {
  return {
    type: SET_SAMPLE_PROCESSING,
    id,
    status,
  };
}

export const SET_SAMPLE_VALUE_DISPLAY = "SET_SAMPLE_VALUE_DISPLAY";
export function setSampleValueDisplay(id, status) {
  return {
    type: SET_SAMPLE_VALUE_DISPLAY,
    id,
    status,
  };
}

export const SET_SAMPLE_SELECTABLE = "SET_SAMPLE_SELECTABLE";
export function setSampleSelectable(id, status) {
  return {
    type: SET_SAMPLE_SELECTABLE,
    id,
    status,
  };
}

export const INCREASE_SAMPLES_PROCESSED = "INCREASE_SAMPLES_PROCESSED";
export function increaseSamplesProcessed(locationId, type) {
  let acqType;
  if (type === "BMODE") {
    acqType = "BMODE";
  } else if (type === "PICTURE") {
    acqType = "PICTURE";
  } else {
    acqType = "CSI";
  }

  return {
    type: INCREASE_SAMPLES_PROCESSED,
    id: locationId,
    acqType,
  };
}

export const INCREASE_SAMPLES_ACQUIRED = "INCREASE_SAMPLES_ACQUIRED";
export function increaseSamplesAcquired(locationId, acqType, allAcqTypes) {
  return {
    type: INCREASE_SAMPLES_ACQUIRED,
    id: locationId,
    acqType: acqType,
    allAcqTypes: allAcqTypes,
  };
}

export const SET_SAMPLE_ALERT = "SET_SAMPLE_ALERT";
export function setSampleAlert(sampleId, alert) {
  return {
    type: SET_SAMPLE_ALERT,
    id: sampleId,
    alert: alert,
  };
}

export const ADD_NEW_SAMPLE = "ADD_NEW_SAMPLE";
export function addNewSample(newSampleId, locationId, acqType) {
  return {
    type: ADD_NEW_SAMPLE,
    id: newSampleId,
    locationId: locationId,
    acqType,
  };
}

export const SET_SAMPLE_TRIANGLE_POSITION = "SET_SAMPLE_TRIANGLE_POSITION";
export function setSampleTrianglePosition(position) {
  return {
    type: SET_SAMPLE_TRIANGLE_POSITION,
    position: position,
  };
}

// Select sample
export const SET_SELECTED_SAMPLE = "SET_SELECTED_SAMPLE";
export function setSelectedSample(sampleId) {
  return {
    type: SET_SELECTED_SAMPLE,
    sampleId: sampleId,
  };
}

// deselect all samples
export const RESET_SAMPLE_SELECTION = "RESET_SAMPLE_SELECTION";
export function resetSampleSelection() {
  return {
    type: RESET_SAMPLE_SELECTION,
  };
}

// Toggle sample included in study
export const TOGGLE_SAMPLE_INCLUDED = "TOGGLE_SAMPLE_INCLUDED";
export function toggleSampleIncluded(sampleId) {
  return {
    type: TOGGLE_SAMPLE_INCLUDED,
    sampleId: sampleId,
  };
}

// Update note text
export const SET_SAMPLE_NOTE = "SET_SAMPLE_NOTE";
export function setSampleNote(sampleId, text) {
  return {
    type: SET_SAMPLE_NOTE,
    sampleId: sampleId,
    text: text,
  };
}

export const SET_LAST_VIEWED_SAMPLE = "SET_LAST_VIEWED_SAMPLE";
export function setLastViewedSample(locationId, sampleId) {
  return {
    type: SET_LAST_VIEWED_SAMPLE,
    locationId,
    sampleId,
  };
}

// increment samplesAcquired
// increment samplesProcessed
// decrement samplesExcluded
export const INCLUDE_SAMPLE = "INCLUDE_SAMPLE";
export function includeSample(locationId, acqType, allAcqTypes) {
  return {
    type: INCLUDE_SAMPLE,
    locationId,
    acqType,
    allAcqTypes: allAcqTypes,
  };
}

// decrement samplesAcquired
// decrement samplesProcessed
// increment samplesExcluded
export const EXCLUDE_SAMPLE = "EXCLUDE_SAMPLE";
export function excludeSample(locationId, acqType, allAcqTypes) {
  return {
    type: EXCLUDE_SAMPLE,
    locationId,
    acqType,
    allAcqTypes: allAcqTypes,
  };
}

export function updateSamplesDoneFlag() {
  return (dispatch, getState) => {
    let samplesDoneFlag = true;
    let state = getState();
    // If any sample is processing, then samplesDoneFlag is set to False
    for (let sampleId in state.samples.byId) {
      if (state.samples.byId[sampleId].processing) {
        samplesDoneFlag = false;
      }
    }
    dispatch(setSamplesDoneFlag(samplesDoneFlag));
  };
}

export function updateSamplesSavedFlag() {
  return (dispatch, getState) => {
    let samplesSavedFlag = true;
    let state = getState();
    // If any sample has dataSaved=False, then SamplesSavedFlag is set to False
    for (let sampleId in state.samples.byId) {
      if (!state.samples.byId[sampleId].dataSaved) {
        samplesSavedFlag = false;
      }
    }
    dispatch(setSamplesSavedFlag(samplesSavedFlag));
  };
}

export function selectSample(sampleId) {
  return (dispatch, getState) => {
    let state = getState();
    let locId = state.samples.byId[sampleId].locationId;
    if (state.view.mainViewSection.orientation !== "LEFT") {
      // DO NOT select sample and switch to result view if on overview
      dispatch(setSelectedSample(sampleId));
      dispatch(setFocusElement(sampleId));
      dispatch(setLastViewedSample(locId, sampleId));
      dispatch(setMainViewSection("resultFocused"));
    }
  };
}

export function removeSample(data, errorType) {
  return (dispatch, getState) => {
    console.log("REMOVING", data, errorType);
    const state = getState();
    const sampleId = data["uuid"];
    var idByType;
    var acqType;
    let samples = Object.assign({}, state.samples.byId); //copy
    let allIds = state.samples.allIds.slice(0); // copy
    let locationSamples = state.locations.byId[
      state.locations.selectedLocationId
    ].samples.slice(0); // copy
    console.log(data);
    for (var uuid of Object.keys(samples)) {
      console.log(uuid);
      if (sampleId === uuid) {
        if (samples[uuid]["type"] === "BMODE") {
          idByType = state.samples.idByType["BMODE"].slice(0);
          if (idByType.indexOf(uuid) > -1) {
            idByType.splice(idByType.indexOf(uuid), 1);
          }
          acqType = "BMODE";
          samples[uuid]["error"] = { state: true, type: "ACQ" };
          if (allIds.indexOf(uuid) > -1) {
            allIds.splice(allIds.indexOf(uuid), 1);
          }
          if (locationSamples.indexOf(uuid) > -1) {
            locationSamples.splice(locationSamples.indexOf(uuid), 1);
          }
          break;
        } else if (samples[uuid]["type"] !== "PICTURE") {
          idByType = state.samples.idByType["CSI"].slice(0);
          if (idByType.indexOf(uuid) > -1) {
            idByType.splice(idByType.indexOf(uuid), 1);
          }
          acqType = "CSI";
          samples[uuid]["error"] = { state: true, type: "ACQ" };
          if (allIds.indexOf(uuid) > -1) {
            allIds.splice(allIds.indexOf(uuid), 1);
          }
          if (locationSamples.indexOf(uuid) > -1) {
            locationSamples.splice(locationSamples.indexOf(uuid), 1);
          }
          break;
        }
      }
    }
    if (errorType === "ACQ") {
      // if the error occurred during acquisition, don't decrement samplesAcquired
      dispatch(
        removeAcqSampleById(
          samples,
          acqType,
          allIds,
          idByType,
          state.locations.selectedLocationId,
          locationSamples
        )
      );
      dispatch(setAcquiring(false));
    } else {
      // if the error occured during initial view processing, decrement samplesAcquired (because it had been incremented)
      dispatch(
        removeErroredSample(
          samples,
          acqType,
          allIds,
          idByType,
          state.locations.selectedLocationId,
          locationSamples,
          state.protocol.acq_types
        )
      );
      dispatch(setAcquiring(false));
    }
    dispatch(setMainViewSection("sampleFocused"));
  };
}

export function createSample(sampleId, acqType) {
  return (dispatch, getState) => {
    const state = getState();
    const locationId = state.locations.selectedLocationId;

    if (!state.device.acquiring) {
      dispatch(setAcquiring(true)); // if the button press comes from hardware then "set acquiring to true" needs to be here as well
    }
    // add new sample with generated uuid
    // UUID comes from server
    dispatch(addNewSample(sampleId, locationId, acqType)); // add sample to samples reducer, add sample to location reducer
    dispatch(updateSamplesSavedFlag());
  };
}

export const SET_SAMPLE_LOCATION_ID = "SET_SAMPLE_LOCATION_ID";
export function setSampleLocationId(sampleId, locationId) {
  return {
    type: SET_SAMPLE_LOCATION_ID,
    sampleId,
    locationId,
  };
}

export const MOVE_SAMPLE = "MOVE_SAMPLE";
export function moveSample(
  sampleId,
  sampleType,
  currentLocationId,
  newLocationId,
  newLocationCompleted,
  currentLocationCompleted
) {
  return {
    type: MOVE_SAMPLE,
    sampleId,
    sampleType,
    currentLocationId,
    newLocationId,
    newLocationCompleted,
    currentLocationCompleted,
  };
}
export function changeSampleLocation(sampleId, newLocationId) {
  return (dispatch, getState) => {
    const state = getState();
    const sample = state.samples.byId[sampleId];
    const currentStudyLocation = state.locations.byId[sample.locationId];
    const newStudyLocation = state.locations.byId[newLocationId];
    // 1) Change the sample's location Id
    dispatch(setSampleLocationId(sample.id, newLocationId));

    // 2) Move sample Id between locations (change samplesAcquires, samplesProcessed, etc)
    let newLocationTotalSamplesNeeded = 0;
    let newLocationTotalSamplesAcquired = 0;
    let currentLocationTotalSamplesNeeded = 0;
    let currentLocationTotalSamplesAcquired = 0;

    for (let type in Object.keys(state.protocol.acq_types)) {
      let currentLocationSamplesNeeded =
        currentStudyLocation.samplesNeeded[type];
      let currentLocationSamplesAcquired =
        currentStudyLocation.samplesAcquired[type];

      let newLocationSamplesNeeded = newStudyLocation.samplesNeeded[type];
      let newLocationSamplesAcquired = newStudyLocation.samplesAcquired[type];

      currentLocationTotalSamplesNeeded += currentLocationSamplesNeeded;

      if (
        type === sample.type ||
        (type === "CSI" && csiTypes.includes(sample.type))
      ) {
        currentLocationSamplesAcquired -= 1;
        newLocationSamplesAcquired += 1;
      }
      if (currentLocationSamplesAcquired < currentLocationSamplesNeeded) {
        currentLocationTotalSamplesAcquired += currentLocationSamplesAcquired;
      } else {
        currentLocationTotalSamplesAcquired += currentLocationSamplesNeeded;
      }
      newLocationTotalSamplesNeeded += newLocationSamplesNeeded;
      if (newLocationSamplesAcquired < newLocationSamplesNeeded) {
        newLocationTotalSamplesAcquired += newLocationSamplesAcquired;
      } else {
        newLocationTotalSamplesAcquired += newLocationSamplesNeeded;
      }
    }

    dispatch(
      moveSample(
        sample.id,
        csiTypes.includes(sample.type) ? "CSI" : sample.type,
        sample.locationId,
        newLocationId,
        newLocationTotalSamplesAcquired >= newLocationTotalSamplesNeeded,
        currentLocationTotalSamplesAcquired >= currentLocationTotalSamplesNeeded
      )
    );

    // 3) Move alert
    if (sample.alert.state) {
      dispatch(updateLocationAlert(currentStudyLocation.id));
      dispatch(updateLocationAlert(newLocationId));
    }

    // 4) Recalculate average SWS and average thickness for the current and new location
    if (csiTypes.includes(sample.type)) {
      dispatch(calculateShearWaveSpeed(sample.id)); // Calculate for the new location
      if (currentStudyLocation.samplesProcessed.CSI > 1) {
        let otherSample = currentStudyLocation.samples.filter(
          (currentLocationSample) =>
            csiTypes.includes(state.samples.byId[currentLocationSample].type) &&
            currentLocationSample !== sampleId
        )[0];
        dispatch(calculateShearWaveSpeed(otherSample));
      } else {
        dispatch(setAverageShearWaveSpeed(sample.locationId, null, null));
      }
    } else if (sample.type === "BMODE") {
      dispatch(calculateThickness(sample.id)); // Calculate for the new location
      if (currentStudyLocation.samplesProcessed.BMODE > 1) {
        let otherSample = currentStudyLocation.samples.filter(
          (currentLocationSample) =>
            state.samples.byId[currentLocationSample].type === "BMODE" &&
            currentLocationSample !== sampleId
        )[0];
        dispatch(calculateThickness(otherSample));
      } else {
        dispatch(setAverageThickness(sample.locationId, null, null));
      }
    }

    // 5) Switch to location view and selected the new location
    dispatch(selectLocation(newLocationId, state.locations.currentAcqType));
    dispatch(setMainViewSection("sampleFocused"));
    dispatch(setFocusElement(newLocationId));
    dispatch(calculateStudyProgress());
  };
}

export function userToggleSampleIncluded(sampleId) {
  return (dispatch, getState) => {
    const state = getState();
    const locationId = state.locations.selectedLocationId;
    const type = state.samples.byId[sampleId].type;

    // Sample: toggle sample included in sampleReducer
    dispatch(toggleSampleIncluded(sampleId));

    // Location
    if (state.samples.byId[sampleId].includeInStudy) {
      dispatch(excludeSample(locationId, type, state.protocol.acq_types));
    } else {
      dispatch(includeSample(locationId, type, state.protocol.acq_types));
    }
    dispatch(updateLocationAlert(locationId));
    // Recalculate average SWS or Thickness as appropriate
    if (csiTypes.includes(type)) {
      dispatch(calculateShearWaveSpeed(sampleId));
    } else if (type === "BMODE") {
      dispatch(calculateThickness(sampleId));
    }
    dispatch(calculateStudyProgress());
  };
}
